import { EmailAttachmentApi } from '@/api/email-attachment';
import { State } from '@/stores/attachment/state';
import { ActionContext, ActionTree } from 'vuex';

const emailAttachmentApi = new EmailAttachmentApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchEmailAttachmentsAsync = async (context: ActionContext<State, any>) => {
        const response = await emailAttachmentApi.getEmailAttachmentsAsync();
        context.commit('setFiles', response);
    }

    public importEmailAttachmentAsync = async (context: ActionContext<State, any>, file: File) => {
        try {
            await emailAttachmentApi.emailAttachmentAsync(file);
        } catch (e) {
            throw e;
        }
    }
}
